import { useReactFlow, type Node, type SetCenterOptions } from '@xyflow/react';
import type { FlowNodeData } from './useGraphLayout';

/** Pans to the centre of a node's card at its place in the layout; `false` when the node is not laid out. */
export function useCentreOn() {
  const { getInternalNode, setCenter } = useReactFlow<Node<FlowNodeData>>();
  return (target: Node<FlowNodeData> | undefined, options: SetCenterOptions) => {
    if (!target) return false;
    // The canvas carries each card's measured size into its node (`nodesChange` in GraphCanvas); a card React Flow has not
    // measured yet has its slot's size.
    const measured = getInternalNode(target.id)?.measured;
    const width = measured?.width ?? target.initialWidth ?? 0;
    const height = measured?.height ?? target.initialHeight ?? 0;
    void setCenter(target.position.x + width / 2, target.position.y + height / 2, options);
    return true;
  };
}
